import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, Theme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useLocation, useHistory } from "react-router-dom";
import { codeNavigationState } from '../../../utils/webAppTracking';

const useStyles = makeStyles((theme: Theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(0),
    top: theme.spacing(0),
    padding: theme.spacing(1),
  },
}));

export default function FridgeConfirmationDialog() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const fullScreen = useMediaQuery("(max-width:599px)");

  const searchParams = new URLSearchParams(location.search);
  const isOpen =
    searchParams.get("mode") === "preview" &&
    searchParams.get("leave") === "need-confirm";

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={history.goBack}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <IconButton
        aria-label="close"
        color="primary"
        className={classes.closeButton}
        onClick={history.goBack}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle id="alert-dialog-title">
        {"Sei davanti un Foorban Fridge?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Per acquistare vai davanti al fridge e scannerizza il qr code.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={() => history.replace("/code", codeNavigationState('/code', 'menu_preview'))}
        >
          Sono davanti al Foorban Fridge
        </Button>
      </DialogActions>
    </Dialog>
  );
}
